import { render } from "./PdpaModal.vue?vue&type=template&id=f57a4f50&scoped=true"
import script from "./PdpaModal.vue?vue&type=script&lang=js"
export * from "./PdpaModal.vue?vue&type=script&lang=js"

import "./PdpaModal.vue?vue&type=style&index=0&id=f57a4f50&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57a4f50"]])

export default __exports__